module.exports = __webpack_public_path__ + "static/media/Dra-Vanina-Scofano.1356a96b.jpg";